import { ProfessionalData } from "@/entities/professional";
import { useRequiredSignatureSubmission } from "../../hooks/useRequiredSignatureSubmission";
import { SignatureRequiredModal } from "./SignatureRequiredModal";

interface SignatureRequiredModalContainerProps {
  readonly professionalData: ProfessionalData;
}

export const SignatureRequiredModalContainer = ({
  professionalData,
}: SignatureRequiredModalContainerProps) => {
  const { submitSignature } = useRequiredSignatureSubmission(professionalData);
  return <SignatureRequiredModal onSubmit={submitSignature} />;
};
